module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-750-active-bft-4b69bb92955adfe73e13239ef01db6c3.png";